import { network } from 'services/network';

export const getPortfolioTopHeroes = (params) => {
    return network.post('api/bo/getPortfolioTopHeroes', params).then((response) => {
        return response.data;
    });
};
